/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { Button } from "@mui/material";
import { Add } from "@material-ui/icons";
import { DataGridFilterRow } from "cms/components/layout/reuse/find-component/dialog/filters/data-grid-filter-row";
import { ReuseComponentDialogContext } from "cms/components/layout/reuse/find-component/context/index";
import { isArrayNotEmpty, isArrayEmpty } from "utils/empty-exists";

const DataGridFilters = () =>  {
    
    const {
        filters,
        clearFilters,
        addFilter
    } = useContext(ReuseComponentDialogContext);
    
    const onAddFilter = () => {
        addFilter();
    };
    const onClearFilters = () => {
        clearFilters();
    };
    
    return (
        <>
            <div
                key={Date.now()}
                className={"data-grid-filters"}
            >
                {/*  Display Filter Empty State  */}
                {isArrayEmpty(filters) && (
                    <div className='components-filter-header'>
                        
                        Click Add Filter to refine component search.
                        
                    </div>
                )}
                
                {/*  Display Filters  */}
                {isArrayNotEmpty(filters) && filters.map((filter, idx) => {
                    return (
                        <DataGridFilterRow
                            key={`filter-${filter.guid}`}
                            idx={idx}
                            filter={filter}
                        />
                    );
                })}
                
            </div>
            <div className='filter-buttons'>
                
                {/*  Add Filter Button  */}
                <Button
                    style={{ marginLeft: "16px" }}
                    startIcon={<Add />}
                    size={"small"}
                    variant='outlined'
                    onClick={onAddFilter}
                >
                    Add Filter
                </Button>
                
                {/*  Clear Filter Button  */}
                <Button
                    style={{ marginLeft: "16px" }}
                    color='neutral'
                    size='small'
                    variant='text'
                    onClick={onClearFilters}
                >
                    Clear all filters
                </Button>
                
            </div>
        </>
    );
};
export { DataGridFilters };
